import React from 'react';
import './style.scss';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { FlippingCardCloseIcon } from '../icons';
import clsx from 'clsx';

const FlippingCardBack = ({ handleFlip, rendering, className, iconClassName, componentWidth }) => {
  return (
    <div className={clsx('fc-card-back', className)}>
      <div className="fc-card-back-content">
        <div className="fc-card-back-content-placeholders">
          <Placeholder name="jss-fp-back" rendering={rendering} sub={true} />
          {componentWidth === '1120' && (
            <Placeholder name="jss-fp-back-right" rendering={rendering} />
          )}
        </div>
        <div className="fc-card-back-blurry" />
      </div>
      <FlippingCardCloseIcon className={iconClassName} onClick={handleFlip} />
    </div>
  );
};

export default FlippingCardBack;
